import { CHAIN_ID } from '@constants/common/chain.constants';

export enum LiquidityHelperType {
  Common,
  AerodromeCl,
  Shadow,
}

enum DexNames {
  Velodrome = 'Velodrome',
  Uniswap = 'Uniswap',
  Mdex = 'Mdex',
  Knightswap = 'Knightswap',
  PcsV3 = 'Pcs V3',
  CetoSwap = 'CetoSwap',
  Aperture = 'Aperture',
  QuickSwap = 'QuickSwap',
  Equalizer = 'Equalizer',
  SpookySwap = 'SpookySwap',
  Pulsex = 'Pulsex',
  SparkSwap = 'SparkSwap',
  NineInch = '9Inch',
  Alienbase = 'Alienbase',
  Aerodrome = 'Aerodrome',
  AerodromeCl = 'Aerodrome-CL',
  VelodromeCl = 'Velodrome-CL',
  DexSwap = 'DexSwap',
  Wombat = 'Wombat',
  WAGMI = 'WAGMI',
  SHADOW_SWAP_V3 = 'ShadowSwap v3',
  SWAPX_V3 = 'SwapX v3',
}

// eslint-disable-next-line max-len
export const LIQUIDITY_HELPER_BY_DEX_CODE: Record<
  CHAIN_ID,
  Record<number, { name: string; address: string; type: LiquidityHelperType }>
> = {
  [CHAIN_ID.OPTIMISM]: {
    3: {
      name: DexNames.Velodrome,
      address: '0xe995bAc6595a44e597FDd799D9759BCEEd5843E9',
      type: LiquidityHelperType.Common,
    },
    4: {
      name: DexNames.Uniswap,
      address: '0xe995bAc6595a44e597FDd799D9759BCEEd5843E9',
      type: LiquidityHelperType.Common,
    },
    5: {
      name: DexNames.VelodromeCl,
      address: '0x744bb3944a6AB1E8c095a767c083E6a26a5305c1',
      type: LiquidityHelperType.AerodromeCl,
    },
  },
  [CHAIN_ID.BSC]: {
    1: {
      name: DexNames.Mdex,
      address: '0x3f8dF67f895B055841594ae11A98B51b144B0052',
      type: LiquidityHelperType.Common,
    },
    2: {
      name: DexNames.Knightswap,
      address: '0x3f8dF67f895B055841594ae11A98B51b144B0052',
      type: LiquidityHelperType.Common,
    },
    3: {
      name: DexNames.PcsV3,
      address: '0x3f8dF67f895B055841594ae11A98B51b144B0052',
      type: LiquidityHelperType.Common,
    },
    4: {
      name: DexNames.Uniswap,
      address: '0x3f8dF67f895B055841594ae11A98B51b144B0052',
      type: LiquidityHelperType.Common,
    },
    5: {
      name: DexNames.DexSwap,
      address: '0xC42f59667dC8601cD0Dc8Df729714c27f26f9a8e',
      type: LiquidityHelperType.Common,
    },
  },
  [CHAIN_ID.MANTA]: {
    0: {
      name: DexNames.CetoSwap,
      address: '0x03B8D3278Fd916691415421c7C7392EbD39234e4',
      type: LiquidityHelperType.Common,
    },
    1: {
      name: DexNames.Aperture,
      address: '0x03B8D3278Fd916691415421c7C7392EbD39234e4',
      type: LiquidityHelperType.Common,
    },
    2: {
      name: DexNames.QuickSwap,
      address: '0x03B8D3278Fd916691415421c7C7392EbD39234e4',
      type: LiquidityHelperType.Common,
    },
  },
  [CHAIN_ID.PULSE]: {
    0: { name: DexNames.Pulsex, address: '', type: LiquidityHelperType.Common },
    1: {
      name: DexNames.SparkSwap,
      address: '',
      type: LiquidityHelperType.Common,
    },
    3: {
      name: DexNames.NineInch,
      address: '',
      type: LiquidityHelperType.Common,
    },
  },
  [CHAIN_ID.BASE]: {
    0: {
      name: DexNames.Alienbase,
      address: '0xB069A80f7AB721A5AeFbC38f7D6Cf53867A6D0DA',
      type: LiquidityHelperType.Common,
    },
    1: {
      name: DexNames.Aerodrome,
      address: '0xB069A80f7AB721A5AeFbC38f7D6Cf53867A6D0DA',
      type: LiquidityHelperType.Common,
    },
    2: {
      name: DexNames.Equalizer,
      address: '0xB069A80f7AB721A5AeFbC38f7D6Cf53867A6D0DA',
      type: LiquidityHelperType.Common,
    },
    4: {
      name: DexNames.Uniswap,
      address: '0xB069A80f7AB721A5AeFbC38f7D6Cf53867A6D0DA',
      type: LiquidityHelperType.Common,
    },
    5: {
      name: DexNames.AerodromeCl,
      address: '0xcC9922ba878Be1E0a997A1C606Cb5c4106B79333',
      type: LiquidityHelperType.AerodromeCl,
    },
  },
  [CHAIN_ID.ARBITRUM]: {
    0: {
      name: DexNames.DexSwap,
      address: '0x190841ab57d3Dd893DEA8472ae64f0e20D24EfFe',
      type: LiquidityHelperType.Common,
    },
    2: {
      name: DexNames.Wombat,
      address: '0x190841ab57d3Dd893DEA8472ae64f0e20D24EfFe',
      type: LiquidityHelperType.Common,
    },
    3: {
      name: DexNames.PcsV3,
      address: '0x190841ab57d3Dd893DEA8472ae64f0e20D24EfFe',
      type: LiquidityHelperType.Common,
    },
    4: {
      name: DexNames.Uniswap,
      address: '0x190841ab57d3Dd893DEA8472ae64f0e20D24EfFe',
      type: LiquidityHelperType.Common,
    },
  },
  [CHAIN_ID.AVALANCHE]: {
    4: {
      name: DexNames.Uniswap,
      address: '0xdB951FACA86addAe9E80aAb0CF53E60B25575143',
      type: LiquidityHelperType.Common,
    },
  },
  [CHAIN_ID.SONIC]: {
    1: {
      name: DexNames.SpookySwap,
      address: '0x0CCFE7aa238B530de68e348ca4CC33A8B5cE4668',
      type: LiquidityHelperType.Common,
    },
    2: {
      name: DexNames.WAGMI,
      address: '0x0CCFE7aa238B530de68e348ca4CC33A8B5cE4668',
      type: LiquidityHelperType.Common,
    },
    3: {
      name: DexNames.SHADOW_SWAP_V3,
      address: '0xc00d9c40f1dc2aefc05f03fe95a506db01e8fe53',
      type: LiquidityHelperType.Shadow,
    },
    6: {
      name: DexNames.SWAPX_V3,
      address: '0x0CCFE7aa238B530de68e348ca4CC33A8B5cE4668',
      type: LiquidityHelperType.Common,
    },
  },
};

export const DEX_FI_FARM = '0xDe1E437E0Be59B596e69fF58E2BdA9209a72Ce8B';
